import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions';

export const RequestsDetailService = {
  async getRequest(id: string, userId: string, companyId: string) {
    await permissionEngine.assert(userId, 'inventory.requests.view', { companyId });

    const { data: request, error: reqError } = await supabase
      .from('requests')
      .select('*')
      .eq('id', id)
      .eq('company_id', companyId)
      .single();

    if (reqError) throw reqError;

    const [{ data: project }, { data: zone }, { data: requester }] = await Promise.all([
      request.project_id
        ? supabase.from('projects').select('id, name').eq('id', request.project_id).maybeSingle()
        : Promise.resolve({ data: null }),
      request.zone_id
        ? supabase.from('project_zones').select('id, zone_name').eq('id', request.zone_id).maybeSingle()
        : Promise.resolve({ data: null }),
      request.requested_by
        ? supabase.from('user_profiles').select('id, full_name, avatar_path').eq('id', request.requested_by).maybeSingle()
        : Promise.resolve({ data: null }),
    ]);

    const { data: items, error: itemsError } = await supabase
      .from('request_items')
      .select('*')
      .eq('request_id', id);

    if (itemsError) throw itemsError;

    return {
      ...request,
      project,
      zone,
      requester: requester ? { ...requester, avatar_url: requester.avatar_path } : null,
      items: items || [],
    };
  },

  async approveRequest(id: string, userId: string, companyId: string) {
    await permissionEngine.assert(userId, 'inventory.requests.approve', { companyId });

    const { error } = await supabase
      .from('requests')
      .update({
        status_code: 'approved',
        updated_at: new Date().toISOString(),
      })
      .eq('id', id)
      .eq('company_id', companyId);

    if (error) throw error;
  },
};
